import { type PublicConfig } from "@vega-core/appConfigs/PublicConfig.type";

export type PWAConfig = {
  name: string;
  short_name: string;
  description?: string;
  start_url: string;
  display: "browser" | "fullscreen" | "minimal-ui" | "standalone";
  theme_color: string;
  background_color: string;
  icons: {
    src: string;
    sizes: string;
    type: string;
    purpose?: string;
  }[];
};

export function generateManifest(
  config: PublicConfig,
  portalType: "gp" | "lp",
): PWAConfig {
  const isGP = portalType === "gp";

  // Use PWA-specific icons if available, otherwise fall back to theme logos
  const icons = config.pwa?.icons
    ? [
        {
          src: config.pwa.icons["192x192"],
          sizes: "192x192",
          type: "image/png",
          purpose: "any maskable",
        },
        {
          src: config.pwa.icons["512x512"],
          sizes: "512x512",
          type: "image/png",
          purpose: "any maskable",
        },
      ]
    : [
        {
          src: config.theme.logos.logoLight,
          sizes: "192x192",
          type: "image/png",
          purpose: "any maskable",
        },
        {
          src: config.theme.logos.logoLight,
          sizes: "512x512",
          type: "image/png",
          purpose: "any maskable",
        },
      ];
  // shortcut name
  const shortName = config.theme.tabTitle.includes("Leader")
    ? `${config.global.companyName} | Leader`
    : `${config.global.companyName} | Alternative`;

  return {
    name: config.theme.tabTitle,
    short_name: shortName,
    description: `${config.global.companyName} Investment Platform`,
    start_url: isGP ? "/login" : "/",
    display: "standalone",
    theme_color: config.theme.palette.primaryColor,
    background_color: config.theme.palette.primaryColor,
    icons,
  };
}

export function generateManifestJSON(
  config: PublicConfig,
  portalType: "gp" | "lp",
): string {
  const manifest = generateManifest(config, portalType);

  return JSON.stringify(manifest, null, 2);
}
